import { Injectable } from '@angular/core';
import { Calendar } from '@awesome-cordova-plugins/calendar/ngx';
import { AlertController, Platform } from '@ionic/angular';
import { AppState } from './app.service';
import { I18n } from './i18n.service';
import { HabitService } from './habit/habit.service';
import { ToasterService } from './toaster.service';
import mixpanel from 'mixpanel-browser';
@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  eventPollingInterval;
  constructor(private calendar: Calendar, 
    private alertController: AlertController,
    private platform: Platform,
    private appState: AppState,
    private i18n: I18n,
    private habitService: HabitService,
    private toasterService: ToasterService
   ) {
  }

  openCalendar(){
    this.calendar.openCalendar(new Date()).then(
        (msg) => { console.log(msg); },
        (err) => { console.log(err); }
    );
}

   addEvent(title, eventLocation, notes, startDate, endDate, calOptions, success, error) {
    const originalStartDate = new Date(startDate);   
     if (this.platform.is('ios') || this.platform.is('iphone')) {

       this.fetchOldEvents(startDate).then((res) => {
         console.log("res", res)
         this.calendar.createEventInteractivelyWithOptions(title, eventLocation, notes, startDate, endDate, calOptions).then((ev) => {
            if (this.appState.get('scheduledHabitId') && this.appState.get('scheduledHabitId') != undefined) {
             mixpanel.track('scheduling event for action', { originalStartDate: originalStartDate.toISOString() })
        
               this.detectChangeDateTime(startDate, endDate, title, originalStartDate,res)
           
        
           } else {
             mixpanel.track('scheduling event for habit/routine level')
           }
         });
       });
     }
     else {
       if (this.platform.is('android')) {
         calOptions.calendarId = 1;
       }
       this.calendar.createEventInteractivelyWithOptions(title, eventLocation, notes, startDate, endDate, calOptions).then((ev) => {
         this.fetchOldEvents(startDate).then((res) => {
           console.log("res", res)
           this.calendar.listCalendars().then(cals => {
             console.log(cals)
             mixpanel.track("calendar list", { calendarsList: cals })
           }
           );

           if (this.appState.get('scheduledHabitId') && this.appState.get('scheduledHabitId') != undefined) {
             mixpanel.track('scheduling event for action', { originalStartDate: originalStartDate.toISOString() })
        
             //   this.detectChangeDateTime(startDate, endDate, title, originalStartDate,res)
             // }
             // else {
             this.detectChangeDateTimeInAndroid(startDate, endDate, title, originalStartDate, res)
             // }
        
           } else {
             mixpanel.track('scheduling event for habit/routine level')
           }
         });
       });
     }
  }
  async presentAlert() {
    const alert = await this.alertController.create({
      header: this.i18n.t('Enable calendar'),
      subHeader: this.i18n.t('To add events to your calendar, allow calendar permissions for the 1st90 app'),
      message: this.i18n.t('Open Settings')  + ' > 1st90 > ' + this.i18n.t('Calendars'),
      buttons: [
        
        {
          text: this.i18n.t('OK'),
          role: 'confirm',
          handler: () => {
          },
        },
      ],
    });

    await alert.present();
  }

  async fetchOldEvents(startDate) {
      const bufferMs = 60 * 60 * 1000 * 24; // 2 days
    const rangeStart = new Date(new Date(startDate).getTime() - bufferMs);
    const rangeEnd = new Date(new Date(startDate).getTime() + 365 * 24 * 60 * 60 * 1000);
      const oldEvents = await this.calendar.listEventsInRange(
        rangeStart, rangeEnd) // next 24 hrs
    if (oldEvents && oldEvents?.length>0) {
      const oldIds = oldEvents.map(e => e?.event_id || e?.id);
      console.log("old ids", oldIds);
      return oldIds;
    }
    else {
      return null;
    }
  }
  scheduleEvents(title, eventLocation, notes, startDate, endDate, calOptions, success, error, showAlertPrompt?) {
    this.calendar.hasReadWritePermission().then((result) => {
      if (!result) {
    
        this.calendar.requestReadWritePermission().then((v) => {
          this.addEvent(title, eventLocation, notes, startDate, endDate, calOptions, success, error);
          this.appState.set('enableCalander', true);

        }, (r) => {
          if (this.platform.is('ios') && showAlertPrompt) {
            this.presentAlert();
          }
          console.log("Rejected");
        })
      }
      else {
        return this.addEvent(title, eventLocation, notes, startDate, endDate, calOptions, success, error)
       
      }
    })

  }
  getBestMatchingEvent = (events: any[], title: string, originalStartDate, newlyAddedEvent) => {
  const originalTime = new Date(originalStartDate).getTime();

  const matchingEvents = events.filter(e =>
    e.title?.trim().toLowerCase() === title?.trim().toLowerCase() &&
    e.calendar !== 'India Holidays' // ignore holidays or system calendars if needed
  );

  if (matchingEvents.length === 0) return null;

  const closestEvent = matchingEvents.reduce((prev, curr) => {
    const prevDateStr = prev.lastModifiedDate || prev.startDate;
    const currDateStr = curr.lastModifiedDate || curr.startDate;

    const prevTime = new Date(prevDateStr).getTime();
    const currTime = new Date(currDateStr).getTime();

    const prevDiff = Math.abs(prevTime - originalTime);
    const currDiff = Math.abs(currTime - originalTime);

    return currDiff < prevDiff ? curr : prev;
  });
    let isIdAvailable
    if (newlyAddedEvent?.length > 0) {
      isIdAvailable = newlyAddedEvent?.filter(event => event?.lastModifiedDate == closestEvent?.lastModifiedDate || (new Date(event.lastModifiedDate).getTime()) > originalTime)
    }
  if((closestEvent?.lastModifiedDate && (new Date(closestEvent.lastModifiedDate).getTime())>originalTime) || isIdAvailable) 
  {
    mixpanel.track("scheduled closestevent", { closestEvent : closestEvent, newlyAddedEvent: newlyAddedEvent} )
    return newlyAddedEvent?.length>0?newlyAddedEvent[0]: closestEvent;
  }
  else if (closestEvent?.lastModifiedDate && (new Date(closestEvent.lastModifiedDate).getTime()) < originalTime) {
        mixpanel.track("The event is scheduled for a date and time that has already passed.",closestEvent)
    return 0;
  }
    else 
  {
        mixpanel.track("No matching close event scheduled",closestEvent)
    return 0;
    }

};

  detectChangeDateTime(startDate: Date, endDate: Date, title: string, originalStartDate: Date,oldEventIds) {
    // Add buffer window to catch possible changed times
    const bufferMs = 60 * 60 * 1000 * 24; // 2 days
    const rangeStart = new Date(startDate.getTime() - bufferMs);
    const rangeEnd = new Date(startDate.getTime() + 365 * 24 * 60 * 60 * 1000); //365 days

    setTimeout(() => {
      this.calendar.listEventsInRange(rangeStart, rangeEnd).then(events => {
        //const addedEvents = events.filter(e => !oldEventIds?.includes(e?.event_id || e?.id));
        const addedEvents = oldEventIds && oldEventIds?.length > 0
          ? events.filter(e => !oldEventIds?.includes(e?.event_id || e?.id))
          : events;
        const myEvent = this.getBestMatchingEvent(events, title,originalStartDate,addedEvents);
        const start = new Date(myEvent.startDate);
        const end = new Date(myEvent.endDate);
        if (myEvent && myEvent !=1) {
         
          const diffInDaysInStartAndEnd = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
          const diffInDays = (start.getTime() - new Date(originalStartDate)?.getTime()) / (1000 * 60 * 60 * 24)
          const updatedStart = new Date(myEvent.startDate).getTime();
          const original = originalStartDate.getTime();
          if (diffInDays > 30 || diffInDaysInStartAndEnd > 30) {
            if (diffInDaysInStartAndEnd > 30) {
              mixpanel.track('Event duration exceeds 30 days',{startDate: start.toISOString(), endDate: end.toISOString()})
              this.toasterService.warning(this.i18n.t("Event duration exceeds 30 days. Please select a shorter time range."));
            }
            if(diffInDays>30) 
            {
               mixpanel.track('Event scheduling from current day exceeds 30 days. Please select a shorter time range.',{startDate: start.toISOString(), endDate: end.toISOString(), currentDate: originalStartDate})
               this.toasterService.warning(this.i18n.t("Event scheduling from current day exceeds 30 days. Please select a shorter time range."));
            }
            this.calendar.deleteEvent(title, myEvent.location, myEvent.notes, start, end);
          }
          else if (updatedStart !== original) {
             const actionComitTimeDate = start.toISOString()
            const habitId= this.appState.get('scheduledHabitId')
            mixpanel.track('Event is successfully added in your calendar',{startDate: start.toISOString(), endDate: end.toISOString(), habitId: habitId,actionComitTimeDate: actionComitTimeDate})
            if (habitId) {
              this.habitService.scheduleLater(habitId, actionComitTimeDate).subscribe(res => {
                console.log('myevent', actionComitTimeDate, startDate)
                this.appState.set('isEventRescheduled', true);
              });
            }
          } else {
            mixpanel.track("Event time is unchanged.", { eventInfo: myEvent })
            console.log("Event time is unchanged.", myEvent);
          }
        } else if(myEvent==null) {
            mixpanel.track("Event duration exceeds 30 days. Please select a shorter time range and remove the created event in calendar if present")
            this.toasterService.warning(this.i18n.t("Event duration exceeds 30 days. Please select a shorter time range and remove the previously created event"));
        }
        if(myEvent ==1) 
        {
           this.calendar.deleteEvent(title, myEvent.location, myEvent.notes, start, end);
            this.toasterService.warning(this.i18n.t("The event is scheduled for a date and time that has already passed."));
        }
      });
    }, 1500);
  }
  
     getBestMatchingEventInAndroid = (events: any[], title: string, originalStartDate, newAddedEvent) => {
  const originalTime = new Date(originalStartDate).getTime();

  const matchingEvents = events.filter(e =>
    e.title?.trim().toLowerCase() === title?.trim().toLowerCase()
  );

  if (matchingEvents.length === 0) return null;

       const closestEvent = matchingEvents
       .reduce((maxEvent, currentEvent) =>
  currentEvent.event_id > maxEvent.event_id ? currentEvent : maxEvent
);
  // .filter(event => event.dtstart > originalTime) // Only future events
  // .reduce((prev, curr) => {
  //  curr?.event_id>prev?.event_id ? curr : prev;
  // });
console.log('Event with highest ID:', closestEvent, originalTime);
       let timeDiff = Math.abs(closestEvent?.dtstart - originalTime)
       let isIdAvailable = newAddedEvent?.filter(event => event?.event_id == closestEvent?.event_id);
       if ((closestEvent?.dtstart >= originalTime || timeDiff<= 3*60000) &&  isIdAvailable?.length >0) {
         mixpanel.track("scheduled closestevent", { closestEvent:closestEvent,newAddedEvent:newAddedEvent  })
         return closestEvent
       }
       else if ((closestEvent?.dtstart < originalTime) || timeDiff > 3*60000) {
     mixpanel.track("The event is scheduled for a date and time that has already passed.", closestEvent)
         return 1
       }
       else {
         mixpanel.track("No matching close event scheduled", closestEvent)
         return 0;
       }
    }
  
   detectChangeDateTimeInAndroid(startDate: Date, endDate: Date, title: string, originalStartDate: Date,oldEventIds) {
    // Add buffer window to catch possible changed times
    const bufferMs = 60 * 60 * 1000 * 24; // 1 day
    const rangeStart = new Date(new Date(startDate).getTime() - bufferMs);
    const rangeEnd = new Date(new Date(startDate).getTime() + 365 * 24 * 60 * 60 * 1000); //365 days
    let isEventHandled=false
     this.eventPollingInterval = setInterval(() => {
      
       this.calendar.listEventsInRange(rangeStart, rangeEnd).then(events => {
         //  const newEventIds = events.map(e => e.event_id || e.id);
         const now = Date.now();
         const addedEvents = oldEventIds && oldEventIds?.length>0
  ? events.filter(e => !oldEventIds?.includes(e?.event_id || e?.id))
  : events;
        // const addedEvents = events.filter(e => !oldEventIds?.includes(e?.event_id || e?.id));
         console.log("added events data", addedEvents, events, oldEventIds);
         if (addedEvents?.length > 0 && !isEventHandled) {
           isEventHandled = true;
         this. clearEventInterval()
          const myEvent = this.getBestMatchingEventInAndroid(events, title, originalStartDate,addedEvents);
          const start = myEvent.dtstart;
          const end = myEvent.dtend;
          if (myEvent && myEvent != 1) {

            const diffInDaysInStartAndEnd = (end - start) / (1000 * 60 * 60 * 24);
            const diffInDays = (start - new Date(originalStartDate)?.getTime()) / (1000 * 60 * 60 * 24)
            const updatedStart = myEvent.dtstart
            const original = originalStartDate.getTime();
            if (diffInDays > 30 || diffInDaysInStartAndEnd > 30) {
              if (diffInDaysInStartAndEnd > 30) {
                mixpanel.track('Event duration exceeds 30 days', { startDate: new Date(start).toISOString(), endDate: new Date(end).toISOString() })
                this.toasterService.warning(this.i18n.t("Event duration exceeds 30 days. Please select a shorter time range."));
              }
              if (diffInDays > 30) {
                mixpanel.track('Event scheduling from current day exceeds 30 days. Please select a shorter time range.', { startDate: new Date(start).toISOString(), endDate: new Date(end).toISOString(), currentDate: originalStartDate })
                this.toasterService.warning(this.i18n.t("Event scheduling from current day exceeds 30 days. Please select a shorter time range."));
              }
              this.calendar.deleteEvent(title, myEvent.location, myEvent.notes, start, end);
            }
            else if (updatedStart !== original) {
              const actionComitTimeDate = new Date(start).toISOString()
              const habitId = this.appState.get('scheduledHabitId')
              mixpanel.track('Event is successfully added in your calendar', { startDate: new Date(start).toISOString(), endDate: new Date(end).toISOString(), habitId: habitId, actionComitTimeDate: actionComitTimeDate })
              if (habitId) {
                this.habitService.scheduleLater(habitId, actionComitTimeDate).subscribe(res => {
                  console.log('myevent', actionComitTimeDate, startDate)
                  this.appState.set('isEventRescheduled', true);
                });
              }
            } else {
              mixpanel.track("Event time is unchanged.", { eventInfo: myEvent })
              console.log("Event time is unchanged.", myEvent);
            }
          } else if (myEvent == null) {
            mixpanel.track("Event duration exceeds 30 days. Please select a shorter time range and remove the created event n calendar if present")
            this.toasterService.warning(this.i18n.t("Event duration exceeds 30 days. Please select a shorter time range and remove the previously created event"));
          }
          if (myEvent == 1) {
            this.calendar.deleteEvent(title, myEvent.eventLocation, myEvent.event_id, start, end);
            this.toasterService.warning(this.i18n.t("The event is scheduled for a date and time that has already passed."));
          }
        }
        else {
          if (now - startDate.getTime() > 2*60000) {
            mixpanel.track("maximum wating time window is reached and no more event time will store")
           this. clearEventInterval()
          }
          else {
          //  events=  this.calendar.listEventsInRange(rangeStart, rangeEnd)
            //this.detectChangeDateTimeInAndroid(startDate, endDate, title, originalStartDate,oldEventIds)
           }
        }
      });
    },1500);
   }
  
  clearEventInterval() {
    if (this.eventPollingInterval) {
      clearInterval(this.eventPollingInterval)
      this.eventPollingInterval =null
    }
  }
  
}
